var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 114,
    viewBox: "0 0 76 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1472 30.8419V0.826172H11.6196V30.8419H0.326172V113.385H75.4031V30.8419H64.1472ZM19.1236 8.33011H56.6433V30.8419H19.1236V8.33011ZM56.6433 66.1103L41.673 77.8164V98.0396H34.169V85.3955L19.1611 73.6142V60.5199H26.6651V69.9749L34.169 75.828V45.512H41.673V68.2865L49.1393 62.471V53.016H56.6433V66.1103Z",
    fill: "url(#paint0_linear_727_3280)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1143 15.8481H26.6104V23.3521H34.1143V15.8481Z",
    fill: "url(#paint1_linear_727_3280)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1231 15.8481H41.6191V23.3521H49.1231V15.8481Z",
    fill: "url(#paint2_linear_727_3280)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_3280",
    x1: 37.8646,
    y1: 0.826172,
    x2: 37.8646,
    y2: 113.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_3280",
    x1: 30.3623,
    y1: 15.8481,
    x2: 30.3623,
    y2: 23.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_3280",
    x1: 45.3711,
    y1: 15.8481,
    x2: 45.3711,
    y2: 23.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsb);
export default __webpack_public_path__ + "static/media/usb.e946f7bf1341b7bb863c4d36fa639fde.svg";
export { ForwardRef as ReactComponent };